import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger, ProgressBar } from "react-bootstrap";
import Select from 'react-select';
import Switch from "react-switch";
import { CustomCard } from "../../components/Card/CustomCard";
import CustomModal from "../../components/Modal/CustomModal";
import { toast } from 'react-toastify';

import AdmisionMem from "../Registros/PreferenciasContent/AdmisionMem";
import ApPeriodos from "../Registros/PreferenciasContent/ApPeriodos";
import CuposNvoIngreso from "../Registros/PreferenciasContent/CuposNvoIngreso";

import { ConsultPeriodos, PreferenciasAdmin, Guardar, CkhEstudiantes, AnalisisInd, AnalisisIndRem, FinAnalisis, FinAnalisisRem } from "../../funciones/PreferenciasAdminFunction";
import { ConsultCarreras } from '../../funciones/ModalidadesFunction';

class OptionContent2 extends Component {
    state = {
        periodoSel: {
            tit: "",
            id: "",
            nombre: "",
            año: ""
        },
        periodos: [],
        preloaderP: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando Datos"
        },
        periodosDisp: [],
        carreras: [],
        maxCitasAdm: "",
        maxCitasInc: "",
        intervalo: "",
        periodosDispSelect: { value: '', label: ' - Cargando Periodos - ' },
        nextPeriodoSelect: { value: '', label: ' - Cargando Periodos - ' },
        interesSelect: { value: 1, label: '1 Unidad de Crédito' },
        cobroIntereses: { value: 0, label: 'Desactivado' },
        cuotas: "",
        valorUc: "",
        valorUcNi: "",
        valorUcNi2: "",
        valorUc2: "",
        valorDivisa: "",
        vencimiento: "",
        cantErrores: "",
        boton1:{
            icon: "fa fa-save",
            text: "Guardar Cambios"
        },
        boton2:{
            icon: "fa fa-money",
            text: "Aplicar Reconversión",
            disabled: false,
            visible: "inline"
        },
        botonModalReM:{
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        openModaRem: false,
        montoRem: "",
        montoRemDis: false,
        porcentajeRem: 0,
        textCantRem: "Progreso",
        cantEstRem: [],
        desRemDis: false,
        desRem: "APLICACIÓN DE RECONVERSIÓN MONETARIA. GACETA N° 42.185",
        
        pagoHab: false,
        openModauc: false,
        openModaucNi: false,
        botonModalUc:{
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        botonModalUcNi:{
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        porcentaje: 0,
        textCant: "Progreso",
        cantEst: [],
        selectNi: false,

        porcentajeNi: 0,
        textCantNi: "Progreso",
        cobroIns: false,
        inscNi: "",
        inscRg: "",
        DisInscNi: false,
        DisInscRg: false,
        aplCobroIns: true,
        aplCobroReIns: true,
        textCobroIns: "ACTIVADO",
        textCobroReIns: "ACTIVADO",
    }

    componentDidMount = () => {
        PreferenciasAdmin ((resp) => {
            this.setState({
                maxCitasAdm: resp[0].max_citas,
                maxCitasInc: resp[0].max_citas_inscrip,
                intervalo: resp[0].intervalo_citas,
                valorUc: resp[0].valor_uc,
                valorUc2: resp[0].valor_uc_ni,
                valorUcNi: resp[0].valor_uc_ni,
                valorUcNi2: resp[0].valor_uc,
                valorDivisa: resp[0].valorUSD,
                vencimiento: resp[0].dias_mora,
                interesSelect: {value: resp[0].interes_mora, label: `${resp[0].interes_mora} Unidades de Crédito` },
                periodosDispSelect: resp[2],
                nextPeriodoSelect: resp[4],
                cuotas: resp[0].cant_cuotas,
                pagoHab: resp[0].pago_hab,
                cobroIntereses: resp[3],
                cobroIns: resp[0].insc_uc_hab,
                inscNi: resp[0].valor_inscrip_ni,
                inscRg: resp[0].valor_inscrip,
                DisInscNi: !resp[0].insc_uc_hab,
                DisInscRg: !resp[0].insc_uc_hab
            })
        })

        ConsultPeriodos ((resp) => {
            this.setState({
                periodos: resp[0],
                periodosDisp: resp[1]
            })
        })

        ConsultCarreras ((resp) => {
            this.setState({carreras: resp})
        })

        if (this.state.cobroIns === true){
            this.setState({DisInscNi: true, DisInscRg: true})
        }else{
            this.setState({DisInscNi: false, DisInscRg: false})
        }
    }

    cambiaValor = (prop) => (e) => {
        this.setState({
            [prop]: e.target.value
        })
    }

    valorPeriodoDisp = (periodosDispSelect) => {
        this.setState({
            periodosDispSelect,
        });
    }

    valorPeriodoSelect = (nextPeriodoSelect) => {
        this.setState({
            nextPeriodoSelect,
        });
    }

    valorintereses = (interesSelect) => {
        this.setState({
            interesSelect,
        });
    }

    valorCintereses = (cobroIntereses) => {
        this.setState({
            cobroIntereses,
        });
    }

    cambiaUc = () => {
        let {valorUc2, valorUc} = this.state;
        if (valorUc2 === "") return null;
        if (valorUc === valorUc2) return null;
        this.setState({openModauc: true})
    }

    cambiaUcNi = () => {
        let {valorUcNi, valorUcNi2} = this.state;
        if (valorUcNi2 === "") return null;
        if (valorUcNi === valorUcNi2) return null;
        this.setState({openModaucNi: true})
    }

    AddCuposCarr = (id, name, year) => {
        let contenido = {
            tit: "Haz seleccionado",
            id: id,
            nombre: name,
            año: year
        }

        this.setState({periodoSel: contenido})
    }

    analizaInd = (est, percent, respuesta) => {
        let {cantEst, valorUc, valorUc2, valorUcNi, aplCobroIns, aplCobroReIns} = this.state;

        let slidePercent = 100 / ((cantEst.length - 1));
        AnalisisInd (cantEst[est].id_estudiante, valorUc, valorUc2, aplCobroIns, aplCobroReIns, (resp) => {
            if (resp.status === "warning"){
                toast.error(resp.mess,{autoClose: 6000});
            }

            this.setState({
                porcentaje: Math.round(percent),
                textCant: `Analizando Estados de Cuenta: ${est + 1} / ${cantEst.length}`,
            }, () => {
                /* Al Finalizar */
                if (est === (cantEst.length - 1)){
                    this.setState({
                        textCant: "Guardando el valor de la nueva Unidad de Crédito"
                    }, () => {
                        FinAnalisis (valorUc, valorUcNi, () => {
                            toast.info("Se han actualizado correctamente los estados de cuenta",{autoClose: 6000});
                            this.setState({
                                openModauc: false,
                                botonModalUc:{
                                    icon: "fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                                porcentaje: 0,
                                textCant: "Progreso",
                                cantEst: [],
                                valorUc2: valorUc
                            })
                        })
                    })
                }
            })

            let estAct = est + 1;
            let perc = percent + slidePercent;
            if (estAct <= (cantEst.length - 1)) this.analizaInd(estAct, perc, () => {})

            respuesta(1)
        })
    }

    analizaIndNi = (est, percent, respuesta) => {
        let {cantEst, valorUc, valorUcNi2, valorUcNi, aplCobroIns, aplCobroReIns} = this.state;

        let slidePercent = 100 / ((cantEst.length - 1));
        AnalisisInd (cantEst[est].id_estudiante, valorUcNi, valorUcNi2, aplCobroIns, aplCobroReIns, (resp) => {
            if (resp.status === "warning"){
                toast.error(resp.mess,{autoClose: 6000});
            }

            this.setState({
                porcentajeNi: Math.round(percent),
                textCantNi: `Analizando Estados de Cuenta: ${est + 1} / ${cantEst.length}`,
            }, () => {
                /* Al Finalizar */
                if (est === (cantEst.length - 1)){
                    this.setState({
                        textCantNi: "Guardando el valor de la nueva Unidad de Crédito"
                    }, () => {
                        FinAnalisis (valorUc, valorUcNi, () => {
                            toast.info("Se han actualizado correctamente los estados de cuenta",{autoClose: 6000});
                            this.setState({
                                openModaucNi: false,
                                botonModalUcNi: {
                                    icon: "fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                                porcentajeNi: 0,
                                textCantNi: "Progreso",
                                cantEst: [],
                                valorUcNi2: valorUcNi
                            })
                        })
                    })
                }
            })

            let estAct = est + 1;
            let perc = percent + slidePercent;
            if (estAct <= (cantEst.length - 1)) this.analizaIndNi(estAct, perc, () => {})

            respuesta(1)
        })
    }

    analizaIndRem = (est, percent, respuesta) => {
        let { cantEstRem, montoRem, desRem } = this.state;
        let slidePercent = 100 / ((cantEstRem.length - 1));

        AnalisisIndRem (cantEstRem[est].id_estudiante, montoRem, desRem, (resp) => {
            if (resp.status === "warning"){
                toast.error(resp.mess,{autoClose: 6000});
            }

            this.setState({
                porcentajeRem: Math.round(percent),
                textCantRem: `Analizando Estados de Cuenta: ${est + 1} / ${cantEstRem.length}`,
            }, () => {
                /* Al Finalizar */
                if (est === (cantEstRem.length - 1)){
                    this.setState({
                        textCant: "Guardando el valor de la nueva Unidad de Crédito"
                    }, () => {
                        FinAnalisisRem (montoRem, (resp) => {
                            toast.info("Se han actualizado correctamente los estados de cuenta",{autoClose: 6000});
                            this.setState({
                                valorUc: resp.uc,
                                valorUc2: resp.uc,
                                valorDivisa: resp.usd,
                                openModaRem: false,
                                botonModalReM:{
                                    icon: "fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                                porcentajeRem: 0,
                                textCant: "Progreso",
                                cantEstRem: []
                            })
                        })
                    })
                }
            })

            let estAct = est + 1;
            let perc = percent + slidePercent;
            if (estAct <= (cantEstRem.length - 1)) this.analizaIndRem(estAct, perc, () => {})

            respuesta(1)
        })
    }

    confirmaUpdate = () => {
        CkhEstudiantes(this.state.selectNi, "RG", (resp) => {
            this.setState({
                textCant: `Analizando Estados de Cuenta: 0 / ${resp.length}`,
                cantEst: resp
            },() => {
                let ni = 0;
                if (resp.length > 0) {
                    this.analizaInd(ni, 0, (resp2) => { ni += resp2 })
                }
            })
        })
    }

    confirmaUpdateNi = () => {
        CkhEstudiantes(false, "NI", (resp) => {
            this.setState({
                textCantNi: `Analizando Estados de Cuenta: 0 / ${resp.length}`,
                cantEst: resp
            },() => {
                let ni = 0;
                if (resp.length > 0) {
                    this.analizaIndNi(ni, 0, (resp2) => { ni += resp2 })
                }
            })
        })
    }

    confirmaReconversion = () => {
        CkhEstudiantes(true, (resp) => {
            this.setState({
                textCantRem: `Analizando Estados de Cuenta: 0 / ${resp.length}`,
                cantEstRem: resp
            }, () => {
                let ni = 0;
                if (resp.length > 0) {
                    toast.info("Procesando la reconversión monetaria",{autoClose: 6000});
                    this.analizaIndRem(ni, 0, (resp2) => { ni += resp2 })
                }
            })
        })
    }

    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let mateOk = (mensaje) => {
            this.setState({
                boton1:{
                    icon: "fa fa-save",
                    text: "Guardar Cambios"
                },
            }, () => {
                PreferenciasAdmin ((resp) => {
                    this.setState({
                        maxCitasAdm: resp[0].max_citas,
                        maxCitasInc: resp[0].max_citas_inscrip,
                        intervalo: resp[0].intervalo_citas,
                        valorUc: resp[0].valor_uc,
                        valorDivisa: resp[0].valorUSD,
                        vencimiento: resp[0].dias_mora,
                        interesSelect: {value: resp[0].interes_mora, label: `${resp[0].interes_mora} Unidades de Crédito` },
                        periodosDispSelect: resp[2],
                        cuotas: resp[0].cant_cuotas,
                    })
                })

                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }
        
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        mateOk(mensaje[0]);
    }

    Apperiodos = () => {
        let { periodos, preloaderP } = this.state;

        if (periodos.length === 0) return (
            <tr>
                <td colSpan={3} align="center"><i className={preloaderP.icon}></i> {preloaderP.text}</td>
            </tr>
        )

        let numA = 0;
        return (
            periodos.map(option => {
                numA+= 500;
                return(
                    <ApPeriodos key= {option.id} datos = {option} num = {numA} funcion = {(id, name, year) => {this.AddCuposCarr(id, name, year)}}/>
                )
            })
        )
    }

    addCarrera = () => {
        let  { periodoSel, carreras } = this.state;

        if (periodoSel.id === "") return (
            <tr>
                <td colSpan={3} align="center">Primero selecciona un periodo a tu izquierda</td>
            </tr>
        )

        if (carreras.length === 0) return (
            <tr>
                <td colSpan={3} align="center">No existen carreras registradas</td>
            </tr>
        )

        return (
            carreras.map(option => (
                <CuposNvoIngreso key={option.value} datos = {option} periodo ={periodoSel}/>
            ))
        )
    }

    modalUc = () => {
        const {openModauc, botonModalUc, porcentaje, textCant, selectNi} = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>
                    <div>
                        <div style={{fontSize: 10}} className="text-danger">{textCant}</div>
                        <ProgressBar now={porcentaje} striped style={{height: 12}}/>
                        <div align="center" style={{fontSize: 10}}>{parseInt(porcentaje)}%</div>
                    </div>
                    <div>Al cambiar el valor de la Unidad de Crédito tambien puedes actualizar <strong className="text-danger">Todos los Estados de Cuenta</strong> de los estudiantes con deuda.</div>
                    <div style={{fontSize: 10}}>Esta función puede durar varios minutos y no se recomienda apagar el equipo o salir del sistema porque puede ocasionar <strong className="text-danger">Fallas en el Sistema.</strong></div>
                    <div className = 'custom-alert-danger custom-mt-10'>
                        <strong>IMPORTANTE: Si vas agregar el monto de INSCRIPCION o REINSCRIPCION debes primero guardar el monto antes de efectuar el aumento de la U.C</strong>
                    </div>
                    <div className="custom-mt-10 text-primary">
                        <Switch height={12} width={24} checked={selectNi} onChange = {() => {this.setState({selectNi: !selectNi})}}/> <strong>Seleccionar estudiantes no inscritos</strong>
                    </div>
                    <div align="right"><strong>¿Deseas Actualizar TODOS los Estados de Cuenta de los ESTUDIANTES REGULARES?</strong></div>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton1 = {<React.Fragment><i className={botonModalUc.icon}></i> {botonModalUc.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                large = "large"
                isopen =  {openModauc}
                titulo = "Actualización de Estados de Cuenta - ESTUDIANTES REGULARES"
                contenido = {contenido()}
                funcion1 = {() => {
                    if (botonModalUc.disabled === true) return null
                    this.setState({
                        botonModalUc: {
                            icon:"fa fa-spinner fa-spin",
                            text: "Espera",
                            disabled: true
                        }
                    }, () => {
                        this.confirmaUpdate()
                    })
                }}
                funcion2 = {() => {
                    if (botonModalUc.disabled === true) return null
                    this.setState({openModauc: false})
                }}
            />
        );
    }

    modalUcNi = () => {
        const {openModaucNi, botonModalUcNi, porcentajeNi, textCantNi} = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>
                    <div>
                        <div style={{fontSize: 10}} className="text-danger">{textCantNi}</div>
                        <ProgressBar now={porcentajeNi} striped style={{height: 12}}/>
                        <div align="center" style={{fontSize: 10}}>{parseInt(porcentajeNi)}%</div>
                    </div>
                    <div>Al cambiar el valor de la Unidad de Crédito tambien puedes actualizar <strong className="text-danger">Todos los Estados de Cuenta</strong> de los estudiantes con deuda.</div>
                    <div style={{fontSize: 10}}>Esta función puede durar varios minutos y no se recomienda apagar el equipo o salir del sistema porque puede ocasionar <strong className="text-danger">Fallas en el Sistema.</strong></div>
                    <div className = 'custom-alert-danger custom-mt-10'>
                        <strong>IMPORTANTE: Si vas agregar el monto de INSCRIPCION o REINSCRIPCION debes primero guardar el monto antes de efectuar el aumento de la U.C</strong>
                    </div>
                    <div align="right"><strong>¿Deseas Actualizar TODOS los Estados de Cuenta de los ESTUDIANTES NUEVO INGRESO?</strong></div>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton1 = {<React.Fragment><i className={botonModalUcNi.icon}></i> {botonModalUcNi.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                large = "large"
                isopen =  {openModaucNi}
                titulo = "Actualización de Estados de Cuenta - NUEVO INGRESO"
                contenido = {contenido()}
                funcion1 = {() => {
                    if (botonModalUcNi.disabled === true) return null
                    this.setState({
                        botonModalUcNi: {
                            icon:"fa fa-spinner fa-spin",
                            text: "Espera",
                            disabled: true
                        }
                    }, () => {
                        this.confirmaUpdateNi()
                    })
                }}
                funcion2 = {() => {
                    if (botonModalUcNi.disabled === true) return null
                    this.setState({openModaucNi: false})
                }}
            />
        );
    }

    modalReconversion = () => {
        const { botonModalReM, openModaRem, montoRem, montoRemDis, porcentajeRem, textCantRem, desRemDis, desRem } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>
                    <div>
                        <div style={{fontSize: 10}} className="text-danger">{textCantRem}</div>
                        <ProgressBar now={porcentajeRem} striped style={{height: 12}}/>
                        <div align="center" style={{fontSize: 10}}>{parseInt(porcentajeRem)}%</div>
                    </div>
                    <div><strong>IMPORTANTE:</strong> Vas a proceder a aplicar la reconversión monetaria a <strong>TODOS</strong> los estudiantes</div>
                    <div style={{fontSize: 10}}>Esta función puede durar varios minutos y no se recomienda apagar el equipo o salir del sistema porque puede ocasionar <strong className="text-danger">Fallas en el Sistema.</strong></div>
                    <div className="custom-mt-10 text-primary">
                        <Row>
                            <Col md = {5}>
                                <div style = {{fontSize: 10}} className = "text-danger">Ingresa el monto de la reconversión</div>
                                <input type = "number" className = "form-control" disabled = {montoRemDis} onChange = {(e) => {this.setState({montoRem: e.target.value})}} value = {montoRem} placeholder ="Ingresa el monto en Bs."/>
                            </Col>
                            <Col md = {7}>
                                <div style = {{fontSize: 10}} className = "text-danger">Descripción</div>
                                <input type = "text" maxLength = {60} className = "form-control" disabled = {desRemDis} onChange = {(e) => {this.setState({desRem: e.target.value})}} value = {desRem} placeholder ="Descripción del asiento"/>
                            </Col>
                        </Row>
                    </div>
                    <div align="right" className = "custom-mt-20"><strong>¿Deseas Aplicar la RECONVERSIÓN A TODOS los Estados de Cuenta?</strong></div>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton1 = {<React.Fragment><i className={botonModalReM.icon}></i> {botonModalReM.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                large = "large"
                isopen =  {openModaRem}
                titulo = "Reconversión Monetaria"
                contenido = {contenido()}
                funcion1 = {() => {
                    if (botonModalReM.disabled === true) return null

                    switch (true){
                        case (montoRem < 1):
                            toast.error("Debes indicar un monto mayor a 0",{autoClose: 6000});
                        break;
                        case (desRem === "") :
                            toast.error("Debes indicar la descripción",{autoClose: 6000});
                        break;
                        default:
                            this.setState({
                                botonModalReM: {
                                    icon:"fa fa-spinner fa-spin",
                                    text: "Espera",
                                    disabled: true
                                },
                                montoRemDis: true,
                                desRemDis: true
                            }, () => {
                                this.confirmaReconversion()
                            })
                        break;
                    }
                }}
                funcion2 = {() => {
                    if (botonModalReM.disabled === true) return null
                    this.setState({openModaRem: false})
                }}
            />
        );
    }

    contenido = () => {
        const styles = {
            padding: 2, fontSize: 12
        }

        let  { periodoSel, maxCitasAdm, maxCitasInc, intervalo, periodosDispSelect, periodosDisp, cuotas, nextPeriodoSelect, DisInscNi, DisInscRg,
            valorUc, valorUcNi, valorDivisa, vencimiento, interesSelect, cantErrores, boton1, boton2, pagoHab, cobroIntereses, cobroIns, inscNi, inscRg, aplCobroIns, textCobroIns,
            aplCobroReIns, textCobroReIns } = this.state;

        const campos = { maxCitasAdm, maxCitasInc, intervalo, valorUc, valorUcNi,
            valorDivisa, vencimiento, periodosDispSelect, cuotas, interesSelect, pagoHab, cobroIntereses, nextPeriodoSelect, cobroIns, inscNi, inscRg }

        const interesesDisp = () => {
            let content = [];
            for (let i = 2; i < 20; i++){
                content.push({
                    value: i, label: `${i} Unidades de Crédito` 
                })
            }

            return content
        }

        const interesesCDisp = [
            { value: 0, label: 'Desactivado' },
            { value: 1, label: 'Activado' }
        ]

        return (
            <React.Fragment>
                <div className="custom-alert-info custom-mt-20" style={{padding: 5}}>
                    <AdmisionMem />
                </div>
                <Row className="custom-mt-10">
                    <Col md={6}>
                        <div className="text-primary" align="center">Aperturar Periodos</div>
                        <div className="table-responsive" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "43vh", overflowX:"hidden"}}>
                            <Table striped hover bordered style={{marginBottom: 0}}>
                                <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="50%" style={styles}><strong>Nombre</strong></td>
                                    <td align="center" width="50%" style={styles}><strong>Año</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Aperturar</strong></td>
                                </tr>
                                {this.Apperiodos()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="text-primary" align="center">Cupos para Nuevo Ingreso</div>
                        <div className="text-danger" style={{fontSize: 11,}}><strong>{`${periodoSel.tit} ${periodoSel.nombre} ${periodoSel.año}`}</strong></div>
                        <div className="table-responsive" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "43vh", overflowX:"hidden"}}>
                            <Table striped hover bordered style={{marginBottom: 0}}>
                                <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="70%" style={styles}><strong>Carrera</strong></td>
                                    <td colspan={2} align="center" width="30%" style={styles}><strong>Cupos</strong></td>
                                </tr>
                                {this.addCarrera()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
                <div className="custom-alert-info custom-mt-10">Asignación de Citas</div>
                <Row className="custom-mt-10">
                    <Col md={4} className="text-primary">
                        <input type="number" className="form-control" placeholder="Expresada en días" value={maxCitasAdm} onChange={this.cambiaValor("maxCitasAdm")}/>
                        <div style={{fontSize: 11}}>Cantidad máxima de citas diarias por Admisión</div>
                    </Col>
                    <Col md={4} className="text-primary">
                        <input type="number" className="form-control" placeholder="Expresada en días" value={maxCitasInc} onChange={this.cambiaValor("maxCitasInc")}/>
                        <div style={{fontSize: 11}}>Cantidad máxima de citas diarias por Reinscripción</div>
                    </Col>
                    <Col md={4} className="text-primary">
                        <input type="number" className="form-control" placeholder="Expresada en días" value={intervalo} onChange={this.cambiaValor("intervalo")}/>
                        <div style={{fontSize: 11}}>Intervalo mínimo de dias para la asignación de citas</div>
                    </Col>
                </Row>

                <div className="custom-alert-danger custom-mt-10">Inscripción y Cuotas</div>
                <Row  className="custom-mt-10">
                    <Col md={5}>
                        <Select
                            isSearchable ={true}
                            value={periodosDispSelect}
                            onChange={this.valorPeriodoDisp}
                            options={periodosDisp}
                        />
                        <div style={{fontSize: 11}} className="text-danger">Periodo de Inscripción</div>
                    </Col>
                    <Col md={2}>
                        <input type="number" className="form-control" placeholder="Cuotas" value={cuotas} onChange={this.cambiaValor("cuotas")}/>
                        <div style={{fontSize: 11}} className="text-danger">Cantidad de Cuotas</div>
                    </Col>
                    <Col md={5}>
                        <div className = "custom-alert-danger">
                            <Select
                                isSearchable ={true}
                                value={nextPeriodoSelect}
                                onChange={this.valorPeriodoSelect}
                                options={periodosDisp}
                            />
                            <div style={{fontSize: 11}} className="text-danger"><strong>Periodo Siguiente</strong></div>
                        </div>
                    </Col>
                </Row>

                <div className="custom-alert-danger custom-mt-10">Costos</div>
                <Row className="custom-mt-10">
                    <Col md={4} className="text-danger">
                        <input type="number" className="form-control" placeholder="$" value={valorDivisa} onChange={this.cambiaValor("valorDivisa")}/>
                        <div style={{fontSize: 11}}>Valor de la tasa de cambio de Divisas</div>
                    </Col>
                    <Col md={4} className="text-danger">
                        <input type="number" className="form-control" placeholder="Bs" value={valorUcNi} onBlur = {this.cambiaUcNi} onChange={this.cambiaValor("valorUcNi")}/>
                        <div style={{fontSize: 11}}>Unidad de Crédito <strong>NUEVO INGRESO</strong></div>
                    </Col>
                    <Col md={4} className="text-danger">
                        <input type="number" className="form-control" placeholder="Bs" value={valorUc} onBlur = {this.cambiaUc} onChange={this.cambiaValor("valorUc")}/>
                        <div style={{fontSize: 11}}>Unidad de Crédito <strong>ALUMNOS REGULARES</strong></div>
                    </Col>
                    <Col md ={4} className="custom-mt-10">
                        <div style={{fontSize: 11}} className="text-danger">Cobro de Inscripción</div>
                        <div align = "center">
                            <Switch
                                offColor = "#bf4848"
                                onHandleColor = "#fff"
                                onColor = "#bf4848"
                                offHandleColor = "#fff"
                                checked = {cobroIns}
                                onChange = {()=> {
                                    this.setState({cobroIns:!cobroIns},() => {
                                        if (cobroIns === true){
                                            this.setState({DisInscNi: true, DisInscRg: true})
                                        }else{
                                            this.setState({DisInscNi: false, DisInscRg: false})
                                        }
                                    })}
                                } 
                                checkedIcon = { <div style = {{minWidth: 120, marginLeft: 15, paddingTop: 8, fontWeight: "bold", color: "#FFF", fontSize: 14}}>POR MONTO</div> }
                                uncheckedIcon = { <div style = {{minWidth: 120, marginLeft: -35, paddingTop: 8, color: "#FFF", fontWeight: "bold", fontSize: 14}}>POR U.C.</div> }
                                className = "react-switch" height = {35} width = {140}
                            />
                        </div>
                    </Col>
                    <Col md ={4} className="custom-mt-10">
                        <div className = "custom-alert-danger">
                            <Row>
                                <Col md ={8}>
                                    <input type="number" className="form-control" disabled = {DisInscNi} placeholder="Bs" value={inscNi} onChange={this.cambiaValor("inscNi")}/>
                                    <div style={{fontSize: 11}}>Monto de <strong>INSCRIPCIÓN</strong></div>
                                </Col>
                                <Col md ={4} align = "center">
                                    <div style={{fontSize: 8}}><strong>Activar Cobro</strong></div>
                                    <div align = "center">
                                        <Switch
                                            offColor = "#bf4848"
                                            onHandleColor = "#fff"
                                            onColor = "#5cb85c"
                                            offHandleColor = "#fff"
                                            checked = {aplCobroIns}
                                            onChange = {()=> {
                                                this.setState({aplCobroIns:!aplCobroIns},() => {
                                                    if (aplCobroIns === false){
                                                        this.setState({textCobroIns: "ACTIVADO"})
                                                    }else{
                                                        this.setState({textCobroIns: "DESACTIVADO"})
                                                    }
                                                })}
                                            }
                                            className = "react-switch" height = {20} width = {45}
                                        />
                                    </div>
                                    <div align = "center" style={{fontSize: 8}}><strong>{textCobroIns}</strong></div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md ={4} className="custom-mt-10">
                        <div className = "custom-alert-danger">
                            <Row>
                                <Col md ={8}>
                                    <input type="number" className="form-control" disabled = {DisInscRg} placeholder="Bs" value={inscRg} onChange={this.cambiaValor("inscRg")}/>
                                    <div style={{fontSize: 11}}>Monto de <strong>REINSCRIPCIÓN</strong></div>
                                </Col>
                                <Col md ={4}>
                                    <div style={{fontSize: 8}}><strong>Activar Cobro</strong></div>
                                    <div align = "center">
                                        <Switch
                                            offColor = "#bf4848"
                                            onHandleColor = "#fff"
                                            onColor = "#5cb85c"
                                            offHandleColor = "#fff"
                                            checked = {aplCobroReIns}
                                            onChange = {()=> {
                                                this.setState({aplCobroReIns:!aplCobroReIns},() => {
                                                    if (aplCobroReIns === false){
                                                        this.setState({textCobroReIns: "ACTIVADO"})
                                                    }else{
                                                        this.setState({textCobroReIns: "DESACTIVADO"})
                                                    }
                                                })}
                                            }
                                            className = "react-switch" height = {20} width = {45}
                                        />
                                    </div>
                                    <div align = "center" style={{fontSize: 8}}><strong>{textCobroReIns}</strong></div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
                
                <Row>
                    <Col md ={9}>
                        <div className="custom-alert-danger custom-mt-10">Cobranza Morosa</div>
                        <Row className="custom-mt-10">
                            <Col md={3} className="text-danger">
                                <input type="number" className="form-control" placeholder="Dias" value={vencimiento} onChange={this.cambiaValor("vencimiento")}/>
                                <div style={{fontSize: 11}}>Dias de vencimiento de Aranceles</div>
                            </Col>
                            <Col md={5} className="text-danger">
                                <Select
                                    isSearchable ={true}
                                    value={interesSelect}
                                    onChange={this.valorintereses}
                                    options={interesesDisp()}
                                />
                                {/* <input className="form-control" placeholder="%" value={intereses} onChange={this.cambiaValor("intereses")}/> */}
                                <div style={{fontSize: 11}}>Intereses por cobranza morosa en Unidades de Crédito</div>
                            </Col>
                            <Col md={4} className="text-danger">
                                <Select
                                    isSearchable ={true}
                                    value={cobroIntereses}
                                    onChange={this.valorCintereses}
                                    options={interesesCDisp}
                                />
                                <div style={{fontSize: 11}}>Activar el cobro de intereses</div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md ={3}>
                        <div className="custom-alert-danger custom-mt-10">Habilitar Pagos</div>
                        <div className="custom-mt-10" align="center">
                            <Switch
                                offColor = "#bf4848"
                                onHandleColor = "#fff"
                                onColor = "#5cb85c"
                                offHandleColor = "#fff"
                                checked = {pagoHab}
                                onChange = {()=> {this.setState({pagoHab:!pagoHab})}} 
                                checkedIcon = { <div style = {{minWidth: 120, marginLeft: 23, paddingTop: 8, fontWeight: "bold", color: "#FFF"}}>ACTIVADO</div> }
                                uncheckedIcon = { <div style = {{minWidth: 120, marginLeft: -47, paddingTop: 10, color: "#FFF", fontWeight: "bold", fontSize: 12}}>DESACTIVADO</div> }
                                className = "react-switch" height = {35} width = {140}
                            />
                        </div>
                    </Col>
                </Row>

                <Row className="custom-mt-20">
                    <Col md={6}>
                        <div className="text-danger">{ cantErrores }</div>
                    </Col>
                    <Col md={6} align="right">
                        <div className = "btn-group">
                            <button className="btn btn-danger btn-sm" onClick = {() => {this.setState({ openModaRem: true })}} style = {{borderWidth: 1, display: boton2.visible}} disabled = {boton2.disabled}><i className={boton2.icon}></i> {boton2.text}</button>
                            <button className="btn btn-primary btn-sm" onClick={()=> {
                                this.setState({
                                    boton1:{
                                        icon:"fa fa-spinner fa-spin",
                                        text: "Espera"
                                    }
                                }, () => {
                                    Guardar (campos, (resp) => { this.respuestaGuardar(resp) })
                                })
                            }} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <React.Fragment>
            <div align="justify">En este módulo puedes cambiar las configuraciones del sistema correspondientes a Administración.</div>
            <div className="custom-alert-info custom-mt-10">Admisión</div>
            <div align="justify" className="custom-mt-10">
                En esta sección puedes aperturar periodos (Previamente agregados por el personal Directivo) para que los estudiantes <strong>Nuevo Ingreso</strong> puedan optar por un cupo.
            </div>
            <div align="justify" className="custom-mt-10">
                Para aperturar un periodo activa la casilla <Switch height={12} width={24} checked={true}/> y éste quedará automáticamente agregado.
            </div>
            <div align="justify" className="custom-mt-10">
                Al aperturar o hacer click en un periodo, aparecerá en la parte derecha de esta sección las carreras con un recuadro para ingresar la cantidad decupos disponibles para <strong>Nuevo Ingreso</strong>
            </div>
            <div align="justify" className="custom-mt-10">
                Para agregar los cupos simplemente ingresa la cantidad disponible en la carrera y haz click en cualquier lugar fuera del recuadro. Verás como el ícono <i className="text-muted fa fa-circle"></i> cambia a <i className="text-success fa fa-check"></i> indicándote que se almacenaron los cambios correctamente, en caso contrario verás el ícono <i className="text-danger fa fa-times"></i>
            </div>

            <div className="custom-alert-danger custom-mt-10">Otras Configuraciones</div>
            <div align="justify" className="custom-mt-10">
                En esta última sección puedes encontrar diversos campos de texto <strong>(cuya función se encuentra explicada debajo de cada uno)</strong>. Para actualizar estos campos, agrega el nuevo valor y presiona el botón  <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i> Guardar Cambios</button>
            </div>
            <div align="justify" className="custom-mt-10">
                Un mensaje de información te indicará cuando los datos hayan sido guardados
            </div>

            <div align="justify" className="custom-mt-10">
                <strong>El campo Periodo de Inscripción</strong> indica el periodo habilitado para la inscripción de los estudiantes
            </div>
            <div align="justify" className="custom-mt-10">
                <strong>Nota: para ver las configuraciones de fechas selecciona <span className="text-primary">OPCIONES DE FECHA</span> ubicado de la parte superior</strong>
            </div>
        </React.Fragment>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={9}>
                        <div>
                            {this.contenido()}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Preferencias</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalUc()}
                {this.modalUcNi()}
                {this.modalReconversion()}
            </div>
        );
    }
}
 
export default OptionContent2;


// WEBPACK FOOTER //
// ./src/views/Opciones/OptionContent2.jsx